var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconB2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 6.5H13.4333C11.0064 6.5 9.79299 6.5 8.86604 6.97231C8.05067 7.38776 7.38776 8.05067 6.97231 8.86604C6.5 9.79299 6.5 11.0064 6.5 13.4333V17.3333M17.3333 45.5H13.4333C11.0064 45.5 9.79299 45.5 8.86604 45.0277C8.05067 44.6122 7.38776 43.9493 6.97231 43.134C6.5 42.207 6.5 40.9936 6.5 38.5667V34.6667M45.5 17.3333V13.4333C45.5 11.0064 45.5 9.79299 45.0277 8.86604C44.6122 8.05067 43.9493 7.38776 43.134 6.97231C42.207 6.5 40.9936 6.5 38.5667 6.5H34.6667M45.5 34.6667V38.5667C45.5 40.9936 45.5 42.207 45.0277 43.134C44.6122 43.9493 43.9493 44.6122 43.134 45.0277C42.207 45.5 40.9936 45.5 38.5667 45.5H34.6667M26 36.8333L26 15.1667M15.1667 26H36.8333",
    stroke: "#00AAFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconB2);
export default __webpack_public_path__ + "static/media/icon-b-2.cac7d2b3e982e3debc84b08cd955bfcd.svg";
export { ForwardRef as ReactComponent };